<template>
    <v-card>
      <v-form @keyup.native.prevent="saveData" @submit="saveData" onSubmit="return false;">
      <v-card-title class="headline py-2">
        Добавить данные
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <DatetimePicker clearable v-model="date" hint="Дата и время" label="Дата" :scrollable="false" format="YYYY-MM-DD HH:mm"></DatetimePicker>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-btn color="success" @click="saveData" :disabled="!this.dateFormatted">Добавить</v-btn>
      </v-card-actions>
      </v-form>
    </v-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import DatetimePicker from '@/components/DatetimePicker'
  
  export default {
    name : 'DataDateForm',
  
    components: {
      DatetimePicker,
    },
    
    computed:{
      ...mapGetters('app/helpers',['formatDatetime']),
      dateFormatted(){
        return this.formatDatetime(this.date).dots
      },
    },
    
    data() {
      return {
        date: moment.utc().format('YYYY-MM-DD HH:mm'),
        menu: false,
        menu2: false
      }
    },
    
    methods : {
      saveData(){
        if(this.date) this.$emit('save', { type: 'value', date: this.date, dateFormatted: this.dateFormatted })
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Forms/DataDateForm.vue